/*! @azure/msal-browser v5.19.0 2026-08-18 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
// Status Codes that can be thrown by WAM
const USER_INTERACTION_REQUIRED = "USER_INTERACTION_REQUIRED";
const USER_CANCEL = "USER_CANCEL";
const NO_NETWORK = "NO_NETWORK";
const DISABLED = "DISABLED";
const ACCOUNT_UNAVAILABLE = "ACCOUNT_UNAVAILABLE";
const UI_NOT_ALLOWED = "UI_NOT_ALLOWED";

export { ACCOUNT_UNAVAILABLE, DISABLED, NO_NETWORK, UI_NOT_ALLOWED, USER_CANCEL, USER_INTERACTION_REQUIRED };
//# sourceMappingURL=NativeStatusCodes.mjs.map
